import styles from "./checkout.module.css";
import { useCheckout } from "./checkout-provider";
import { CTAButton } from "BEDROCK/shared-components/cta-button";
import { useImageStore } from "entity-store/image-store/use-image-store";
import { useEffect } from "react";
import { useProjectStore } from "entity-store/project-store/use-project-store";
import { usePaths } from "BEDROCK/paths";
import { useState } from "react";
import { PosterProject } from "PosterEditor/model/poster-project";
import { CheckoutItem } from "./checkout-provider";

interface CheckoutProps {}

export const PostCheckout = (props: CheckoutProps) => {
  const { navigateTo, home, projectList } = usePaths();
  const { getRenderedResultImageURL } = useImageStore();
  const {
    checkout,
    clearCheckout,
    updateItem: updateCheckoutItem,
  } = useCheckout();

  const [error, setError] = useState<string | undefined>(undefined);

  useEffect(() => {
    if (checkout.items.length === 0) {
      navigateTo(home);
    } else {
      const projectIDs = checkout.items.map((item) => item.id);
      projectIDs.forEach((projectID) => {
        getImageForProject(projectID)
          .then((imageURL) => {
            if (imageURL) {
              const item = checkout.items.find((item) => item.id === projectID);
              if (item) {
                item.imageURL = imageURL;
                updateCheckoutItem(item);
              }
            } else {
              setError("Rendered image not found");
            }
          })
          .catch((error) => {
            console.error("Error fetching image:", error);
            setError("Error fetching image");
          });
      });
    }
  }, []);

  const getImageForProject = async (id: string) => {
    return getRenderedResultImageURL(id).then((imageURL) => {
      if (imageURL) {
        return imageURL;
      } else {
        setError("Rendered image not found");
      }
    });
  };

  return (
    <div className={styles.container}>
      <h1>Confirm</h1>
      {checkout.items.map((item) => (
        <SingleCheckoutItem key={item.id} item={item} />
      ))}
    </div>
  );
};

interface SingleCheckoutItemProps {
  item: CheckoutItem;
}

const SingleCheckoutItem = (props: SingleCheckoutItemProps) => {
  const imageURL = props.item.imageURL;

  return (
    <div>
      {imageURL && (
        <img
          src={imageURL}
          alt="Rendered Project"
          className={styles.renderedImage}
        />
      )}
    </div>
  );
};
